export const MESSAGE_COLlECTION = "messages";
export const CONVERSATION_COLlECTION = "conversations";
export const USER_COLlECTION = "users";
export const PRESENCE_REALTIME = "presence";
export const UNREAD_REALTIME = "unreads";
export const DELIVERY_REALTIME = "deliveries";
